var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Add")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact/Pricing_Parameters_Collapsed",
    transform: "translate(-993.000000, -12.000000)",
    fill: "#335498",
    stroke: "#335498",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-(3)",
    transform: "translate(994.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0 C2.916,0 0,2.91575 0,6.5 C0,10.08425 2.916,13 6.5,13 C10.084,13 13,10.08425 13,6.5 C13,2.91575 10.084,0 6.5,0 Z M6.5,12.5 C3.19175,12.5 0.5,9.80825 0.5,6.5 C0.5,3.19175 3.19175,0.5 6.5,0.5 C9.80825,0.5 12.5,3.19175 12.5,6.5 C12.5,9.80825 9.80825,12.5 6.5,12.5 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74074074,6.11111111 L6.75925926,6.11111111 L6.75925926,3.25925926 C6.75925926,3.11588889 6.64311111,3 6.5,3 C6.35688889,3 6.24074074,3.11588889 6.24074074,3.25925926 L6.24074074,6.11111111 L3.25925926,6.11111111 C3.11614815,6.11111111 3,6.227 3,6.37037037 C3,6.51374074 3.11614815,6.62962963 3.25925926,6.62962963 L6.24074074,6.62962963 L6.24074074,9.74074074 C6.24074074,9.88411111 6.35688889,10 6.5,10 C6.64311111,10 6.75925926,9.88411111 6.75925926,9.74074074 L6.75925926,6.62962963 L9.74074074,6.62962963 C9.88385185,6.62962963 10,6.51374074 10,6.37037037 C10,6.227 9.88385185,6.11111111 9.74074074,6.11111111 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Add-Circle.f33c6e0e.svg";
export { ForwardRef as ReactComponent };